import { mapGetters, mapActions } from 'vuex'

import ScrollableList from '@/components/ScrollableList/index'

export default {
  name: 'results',
  components: {
    ScrollableList
  },
  data: () => ({
    baseUrl: '/app/dashboard/result',
    pageArr: null,

    defaultPoints: [
      { label: 'Home', value: 10 },
      { label: 'Away', value: 9 },
      { label: 'Draw', value: 7.5 },
      { label: 'Bonus', value: 5 }
    ]
  }),
  computed: {
    ...mapGetters('results', {
      resultsPageResponse: 'RESULTS_PAGE'
    })
  },
  methods: {
    ...mapActions('results', {
      fetchResultsPageAction: 'FETCH_RESULTS_PAGE'
    })
  },
  activated() {
    this.fetchResultsPageAction().then(() => {
      this.pageArr = this.resultsPageResponse.data
    })
  }
}
